export default {
    loggedIn: false,
    token: ''
}
